module.exports = __webpack_public_path__ + "img/font.c5257199.svg";